import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
  },
  input: {
    width: '100%', // Garantir que os campos ocupem 100% do espaço dentro do Grid
    marginBottom: theme.spacing(2), // Espaçamento entre os campos
  },
  formControl: {
    width: '100%', // Certificar que os campos Select também tenham 100% de largura do contêiner
  },
  gridItem: {
    // Limitar o tamanho de cada campo para 25% da tela
    width: '25%',  // 25% da largura da tela
    [theme.breakpoints.down('sm')]: {
      width: '100%', // Em telas pequenas (como celulares), os campos ocupam 100% da largura
    },
  },
}));